export const START_PAGE_TAB_VIEW_QUERY_PARAM = 'tv';

export enum MainActionTabs {
    RESEARCH_TOPIC = 'researchTopic',
    STOCK_SCREENER = 'stockScreener',
    COMPANY_SEARCH = 'companySearch',
}

export const MAIN_NAV_RESEARCH_LINKS = {
    iconType: 'book',
    label: 'Research',
    subMenu: [
        {
            label: 'Research a topic',
            tab: MainActionTabs.RESEARCH_TOPIC,
            tabIndex: 3,
        },
        {
            label: 'Stock screener',
            tab: MainActionTabs.STOCK_SCREENER,
            tabIndex: 4,
        },
        {
            label: 'Find companies',
            tab: MainActionTabs.COMPANY_SEARCH,
            tabIndex: 5,
        },
    ],
    tabIndex: 2,
};

export const MAIN_NAV_BUILD_LINKS = {
    iconType: 'cube',
    label: 'Build',
    subMenu: [
        { href: '/index-builder/create', label: 'Search for securities', tabIndex: 7 },
        {
            href: '/index-builder/create',
            label: 'Load an existing portfolio',
            tabIndex: 8,
        },
        { href: '/index-builder/create/backtest', label: 'Backtest', tabIndex: 9 },
    ],
    tabIndex: 6,
};

export const MAIN_NAV_DIRECT_LINKS: Array<{ href: string; label: string; tabIndex: number }> = [];
export const MAIN_NAV_LINKS = [MAIN_NAV_RESEARCH_LINKS, MAIN_NAV_BUILD_LINKS, ...MAIN_NAV_DIRECT_LINKS];

export enum MainFooterLinkGroups {
    PRODUCT = 'product',
    LEARN = 'learn',
    COMPANY = 'company',
}

export const MAIN_FOOTER_LINKS = [
    {
        group: {
            key: MainFooterLinkGroups.PRODUCT,
            label: 'Product',
        },
        navLinks: [
            { href: '/index-builder/create', label: 'Search for securities', tabIndex: 7 },
            {
                href: '/index-builder/create',
                label: 'Load an existing portfolio',
                tabIndex: 8,
            },
            { href: '/index-builder/create/backtest', label: 'Backtest', tabIndex: 9 },
        ],
    },
];
